export enum WsConnectionState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  ERROR = 'error'
}

export enum WsMessageKind {
  CHAT_MESSAGE = 'chat_message'
}

export interface WsPublicationData {
  kind: WsMessageKind;
  data: unknown;
}

export type WsChannelListener = (data: WsPublicationData) => void;

export const WS_CONFIG = {
  minReconnectDelay: 1000,
  maxReconnectDelay: 30000,
  timeout: 10000,
  maxServerPingDelay: 10000
} as const;
